import { cva, cx } from 'class-variance-authority'
import type { ReactNode } from 'react'

import { Flex } from '../Flex/Flex'
import { Text } from '../Text/Text'

import styles from './FieldCard.module.scss'

interface FieldCardProps {
  label?: string
  children: ReactNode
  className?: string
  labelSize?: '1' | '2' | '3'
}

const fieldCard = cva(styles.fieldCard)

export const FieldCard = ({
  label,
  children,
  className,
  labelSize = '1'
}: FieldCardProps) => {
  return (
    <Flex className={cx(fieldCard(), className)} direction="column">
      {label && (
        <Text as="label" mb="2" size={labelSize} weight="medium">
          {label}
        </Text>
      )}
      {children}
    </Flex>
  )
}

FieldCard.displayName = 'FieldCard'
